export const PATH_DATA = "/data"
export const PATH_EVENTS = "/events"
export const PATH_MAIN = "/main"
export const PATH_FUNCTIONS = "/functions"
export const PATH_BUTTONS_MAIN = "/buttons/main"
export const PATH_BUTTONS_BACK = "/buttons/back"
export const PATH_HAPTIC = "/haptic"
export const PATH_SERVER = "/server"

export const PATH_FUNCTIONS_BASIC = `${PATH_FUNCTIONS}/basic`
export const PATH_FUNCTIONS_ALERTS = `${PATH_FUNCTIONS}/alerts`
export const PATH_FUNCTIONS_EVENTS = `${PATH_FUNCTIONS}/events`
export const PATH_FUNCTIONS_BOT = `${PATH_FUNCTIONS}/bot`
export const PATH_FUNCTIONS_THEME = `${PATH_FUNCTIONS}/theme`
export const PATH_FUNCTIONS_LINKS = `${PATH_FUNCTIONS}/links`
export const PATH_FUNCTIONS_QR = `${PATH_FUNCTIONS}/qr`
